import type { FC } from 'react'

import type { Locale } from '@skytech/types'

import { useFormattedNumberWithCurrency } from '@/hooks/use-formatted-number-with-currency'

export const FormattedNumberWithCurrency: FC<{
  amount: number
  currency?: Intl.NumberFormatOptions['currency'] | null
  locale?: Locale
  precision?: number
}> = ({ amount, currency, locale, precision }) => {
  const { formatNumber } = useFormattedNumberWithCurrency()

  return (
    <span>
      {formatNumber({
        amount,
        locale,
        currency,
        precision,
      })}
    </span>
  )
}
